var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 826,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 827,
	"./assets/thewest-digital-hero-variation-a.jpg": 2858,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 828,
	"./assets/thewest-digital-hero-variation-b.jpg": 2859,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 829,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2860,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 830,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2861,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 831,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2862,
	"./assets/thewest-digital-hero.jpg": 2863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2857;